"use client";
import React, { useContext, useEffect, useRef, useState } from "react";
import Icons from "../../components/Icons";
import { Context } from "../contexts/AppContext";
import { v4 as uuidv4 } from "uuid";
import { getData, postData } from "../../lib/utils";
//import imageCompression from "browser-image-compression";

function UploadPhoto(props) {
  const [imageFiles, setImageFiles] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const xhrRefs = useRef({});
  const [totalFileUploaded, setTotalFileUploaded] = useState(0);

  const { value, progress } = useContext(Context);
  const [appState] = value;

  const { currentFolderData, currentGalleryData } = appState;
  const { showProgressBar, cancelledIdsRef } = progress;


  

  const sanitizeFileName = (name) =>
    name;//.replace(/[^a-zA-Z0-9_.]/g, "");


  const [isDragging, setIsDragging] = useState(false);

const readAllEntries = async (directoryReader) => {
  const entries = [];

  while (true) {
    const batch = await new Promise((resolve) =>
      directoryReader.readEntries(resolve)
    );

    if (!batch.length) break;

    entries.push(...batch);
  }

  return entries;
};

const handleDrop = async (e) => {
  e.preventDefault();
  setIsDragging(false);

   

  const items = [...e.dataTransfer.items];
  const files = [];

const traverse = async (entry, parentPath = "") => {
  if (entry.isFile) {
    return new Promise((resolve) => {
      entry.file((file) => {
        if (file.type.startsWith("image/")) {
          file.folderName = parentPath.split("/")[0] || "";
        console.log("folder name === ",parentPath)
          files.push(file);
        }
        resolve();
      });
    });
  }

  if (entry.isDirectory) {
    const currentPath = parentPath
      ? `${parentPath}/${entry.name}`
      : entry.name;

    const reader = entry.createReader();
    const entries = await readAllEntries(reader);

    await Promise.all(
      entries.map((child) => traverse(child, currentPath))
    );
  }
};

  await Promise.all(
    items.map((item) => {
      const entry = item.webkitGetAsEntry();
      return entry ? traverse(entry) : Promise.resolve();
    })
  );

  console.log("Total files:", appState);
 

  const plan = appState?.adminDetails?.plan;
  console.log("apppppppppppp", appState)
  //alert(appState?.adminDetails?.plan)

if (plan?.planType === "imageonly") {
  const remainingPhotos =
    (plan.photoLimit || 0) -
    (plan.currentPhotoCount || 0);
  
   alert(files.length +" "+remainingPhotos)

  if (files.length > remainingPhotos) {
    alert(
      `You can upload only ${remainingPhotos} more photos.`
    );
    return;
  }
}


  setImageFiles(files);
};

useEffect(() => {
  const handleDragEnter = (e) => {
    e.preventDefault();

    if (
      e.dataTransfer?.types?.includes("Files")
    ) {
      setIsDragging(true);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDragLeave = (e) => {
    e.preventDefault();

    // cursor browser window se bahar gaya
    if (
      e.clientX === 0 ||
      e.clientY === 0 ||
      e.clientX >= window.innerWidth ||
      e.clientY >= window.innerHeight
    ) {
      setIsDragging(false);
    }
  };

 console.log("Handle drop.... ")

  window.addEventListener("dragenter", handleDragEnter);
  window.addEventListener("dragover", handleDragOver);
  window.addEventListener("dragleave", handleDragLeave);
  window.addEventListener("drop", handleDrop);

  return () => {
    window.removeEventListener("dragenter", handleDragEnter);
    window.removeEventListener("dragover", handleDragOver);
    window.removeEventListener("dragleave", handleDragLeave);
    window.removeEventListener("drop", handleDrop);
  };
}, []);

  // -------------------------------
  // 🔥 IMAGE CHECK (IMPORTANT)
  // -------------------------------
  const checkImageExists = (url) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = url;
      img.onload = () => resolve(true);
      img.onerror = () => resolve(false);
    });
  };

  const waitForImage = async (url, retries = 10, delay = 1000) => {
    for (let i = 0; i < retries; i++) {
      const exists = await checkImageExists(url);
      if (exists) return true;
      await new Promise((res) => setTimeout(res, delay));
    }
    return false;
  };

  // -------------------------------
  // FILE SELECT
  // -------------------------------
  const handleFileChange = (event) => {
  

    
  const files = Array.from(event.target.files || []);
  if (!files.length) return;
  
  

  const plan = appState?.adminDetails?.plan;

  // IMAGE ONLY PLAN
  if (plan?.planType === "imageonly") {
    const remainingPhotos =
      (plan.photoLimit || 0) - (plan.currentPhotoCount || 0);
    
    console.log(files.length, " file length ", remainingPhotos);

 

    if (files.length > remainingPhotos) {
      alert(
        `You can upload only ${remainingPhotos} more photos.`
      );
      return;
    }

    setImageFiles(files);
    return;
  }

  // HYBRID / VIDEO PLAN
  const availableCreditsMB = appState?.adminDetails?.credits || 0;

  const totalSizeMB = files.reduce(
    (sum, file) => sum + file.size / (1024 * 1024),
    0
  );

  if (totalSizeMB > availableCreditsMB) {
    alert("Not enough credits!");
    return;
  }

  setImageFiles(files);
};
  useEffect(() => {
    if (imageFiles.length > 0) handleUpload();
  }, [imageFiles]);

  // -------------------------------
  // API CALLS
  // -------------------------------
 

  

 const startMultipartUpload = (file) => {
  const s3Key = getS3Key(file, appState);

  return postData(
    `products/start-multipart-upload?fileName=${encodeURIComponent(s3Key)}&fileType=${file.type}`
  );
};

const getPartUrl = (file, uploadId, partNumber) => {
  const s3Key = getS3Key(file, appState);

  return getData(
    `products/get-part-url?fileName=${encodeURIComponent(s3Key)}&uploadId=${uploadId}&partNumber=${partNumber}`
  );
};

const completeMultipartUpload = (file, uploadId, parts) => {
  const s3Key = getS3Key(file, appState);

  return postData("products/complete-multipart-upload", {
    fileName: s3Key,
    uploadId,
    parts,
  });
};

 const getFolderName = (file) => {
  const name = file.name || "";

  const noExt = name.replace(/\.[^/.]+$/, "");
  const noNumber = noExt.replace(/[0-9]/g, "");
  const clean = noNumber.replace(/[_-]/g, "").trim();

  return clean ? clean.toLowerCase() : noExt;
};

const getS3Key = (file, appState) => {
  const folderName = file.folderName ?? getFolderName(file);

  return `${appState.currentFolderData.adminId}/${appState.currentFolderData.id}/${appState.currentGalleryData._id}/${folderName}/${sanitizeFileName(file.name)}`;
};
  // -------------------------------
  // UPLOAD FILE
  // -------------------------------
  const uploadMultipartFile = async (file, uniqueId, index) => {
  const cleanName = sanitizeFileName(file.name);
  const chunkSize = 5 * 1024 * 1024;
  const totalParts = Math.ceil(file.size / chunkSize);

  showProgressBar?.(cleanName, 0, uniqueId, "uploading");

  try {
    const { uploadId } = await startMultipartUpload(file);

    let parts = [];

    for (let partNumber = 1; partNumber <= totalParts; partNumber++) {
      const start = (partNumber - 1) * chunkSize;
      const end = Math.min(start + chunkSize, file.size);
      const chunk = file.slice(start, end);

      const { url } = await getPartUrl(file, uploadId, partNumber);

      await new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open("PUT", url);

        xhr.upload.onprogress = (e) => {
          if (e.lengthComputable) {
            const percent = Math.round(
              ((start + e.loaded) / file.size) * 100
            );

            showProgressBar?.(cleanName, percent, uniqueId, "uploading");
          }
        };

        xhr.onload = () => {
          if (xhr.status === 200) {
            const eTag = xhr.getResponseHeader("ETag");
            parts.push({ ETag: eTag, PartNumber: partNumber });
            resolve();
          } else reject("Upload failed");
        };

        xhr.onerror = () => reject("Network error");

        xhr.send(chunk);
      });
    }

    await completeMultipartUpload(file, uploadId, parts);

    showProgressBar?.(cleanName, 100, uniqueId, "completed");

    props?.photoUploadedDone?.(
      file,
      (file.size / 1024 / 1024).toFixed(2),
      index,
      imageFiles.length,
      uniqueId,
      file.folderName ?? getFolderName(file)
    );

  } catch (err) {
    console.error(err);
    showProgressBar?.(cleanName, 0, uniqueId, "failed");
  }
};


const normalizeFile = (file) => {
  file.folderName =
    file.folderName ?? getFolderName(file);

  return file;
};
  
  // -------------------------------
  // HANDLE MULTI UPLOAD
  // -------------------------------
const handleUpload = async () => {
  setIsUploading(true);

  const filesToUpload = imageFiles.map(normalizeFile);

  const MAX_CONCURRENT_UPLOADS = 5;
  let currentIndex = 0;
  let activeUploads = 0;

  filesToUpload.forEach((file) => {
    const uniqueId = uuidv4();
    file._uploadId = uniqueId;

    showProgressBar?.(
      sanitizeFileName(file.name),
      0,
      uniqueId,
      "Queued"
    );
  });

  const startNextUpload = () => {
    if (currentIndex >= filesToUpload.length && activeUploads === 0) {
      setIsUploading(false);
      setImageFiles([]);
      return;
    }

    if (currentIndex >= filesToUpload.length) return;

    const file = filesToUpload[currentIndex];
    const uniqueId = file._uploadId;

    currentIndex++;
    activeUploads++;

    (async () => {
      try {
        await uploadMultipartFile(file, uniqueId, currentIndex);
      } finally {
        activeUploads--;
        startNextUpload();
      }
    })();
  };

  for (let i = 0; i < MAX_CONCURRENT_UPLOADS; i++) {
    startNextUpload();
  }
};

return (
  <div>
    {isDragging && (
      <div
        className="fixed inset-0 z-[9999] bg-black/60 flex items-center justify-center"
        onDragOver={(e) => e.preventDefault()}
       // onDrop={handleDrop}
      >
        <div className="bg-white p-10 rounded-lg">
          <h2 className="text-xl font-bold">
            Drop Folder Here
          </h2>
        </div>
      </div>
    )}
    <div className="flex">
   
      <input
      type="file"
      accept="image/png,image/jpeg,image/jpg,image/webp"
      multiple
      onChange={handleFileChange}
      id="fileInput"
      style={{ display: "none" }}
    />

    <button
      onClick={() =>
        document.getElementById("fileInput").click()
      }
      className="bg-gray-800 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded flex gap-2 items-center"
    >
      <Icons.Uploads /> Upload Photos
    </button>

  
    </div>
 
    
  </div>
);
}

export default UploadPhoto;